import type { ICellRendererParams } from '../../../components/ui/table';
import { EntityActionsCellRenderer } from '../../../components/shared/agGridCells';
import type { AcquirerGridContext, AcquirerGridRow } from '../models/types';

export function ActionCell(params: ICellRendererParams<AcquirerGridRow>) {
  const row = params.data;
  const ctx = params.context as AcquirerGridContext;
  if (!row) return null;

  return (
    <EntityActionsCellRenderer
      {...params}
      context={{
        actions: {
          onStatus: (r: AcquirerGridRow) => ctx.onStatus(r),
          onEdit: (r: AcquirerGridRow) => ctx.onEdit(r.id),
          onDelete: (r: AcquirerGridRow) => ctx.onDelete(r),
          statusLabel: 'Change Status',
          editLabel: 'Edit Acquirer',
          deleteLabel: 'Delete Acquirer',
        },
      }}
    />
  );
}
